// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
	mutation MainOrderEditMutation($input: MainOrderEditInput!) {
		MainOrderEdit(input: $input) {
			error
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error) => void) {
	commitMutation(environment, {
		mutation: mutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const r = response.MainOrderEdit;
			console.log(`mutation resp: ${JSON.stringify(r)}`);
			if (r.error !== null) {
				callback(r.error, null);
				return;
			}

			callback(null);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/MainOrderEditMutation.js